module.exports = __webpack_public_path__ + "static/img/pg.97721a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/pg.png
// module id = apkd
// module chunks = 1